/* ==============================================
   CX Mayorista · Theme JS
   ============================================== */

/* ======== v35 motion: shared helpers ======== */
var CX_RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function bumpBadge(el){ if (CX_RM || !el) return; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }

// ======== Language switcher (persist via localStorage) ========
(function() {
  const KEY = 'cx_locale';
  function apply(lang) {
    document.documentElement.setAttribute('data-locale', lang);
    document.body.setAttribute('data-locale', lang);
    /* H4: a11y — sync <html lang> so screen readers + Google detect language correctly */
    document.documentElement.lang = (lang === 'zh') ? 'zh-Hans' : 'es-AR';
    document.querySelectorAll('.lang-switch [data-lang], .nav-drawer-lang [data-lang]').forEach(x => {
      const on = x.dataset.lang === lang;
      x.classList.toggle('active', on);
      if (x.tagName === 'BUTTON') x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const suffix = lang === 'zh' ? 'Zh' : 'Es';
    document.querySelectorAll('[data-placeholder-es]').forEach(el => {
      const v = el.dataset['placeholder' + suffix];
      if (v != null) el.placeholder = v;
    });
    document.querySelectorAll('[data-aria-label-es]').forEach(el => {
      const v = el.dataset['ariaLabel' + suffix];
      if (v != null) el.setAttribute('aria-label', v);
    });
    document.querySelectorAll('option[data-es][data-zh]').forEach(o => {
      o.textContent = lang === 'zh' ? o.dataset.zh : o.dataset.es;
    });
  }
  window.cxApplyLocale = apply;
  const saved = localStorage.getItem(KEY) || document.documentElement.getAttribute('data-locale') || 'es';
  apply(saved);
  document.querySelectorAll('.lang-switch [data-lang], .nav-drawer-lang [data-lang]').forEach(s => {
    s.addEventListener('click', () => {
      const lang = s.dataset.lang;
      localStorage.setItem(KEY, lang);
      apply(lang);
    });
  });
})();

// ======== Product card qty controls ========
document.querySelectorAll('.prod-qty button').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation(); e.preventDefault();
    const wrap = btn.closest('.prod-qty');
    const input = wrap.querySelector('input');
    let v = parseInt(input.value, 10) || 1;
    v = Math.max(1, v + (btn.dataset.step === 'up' ? 1 : -1));
    input.value = v;
    // Cart context: auto-submit form (debounced) so user doesn't need to click 更新
    const cartForm = btn.closest('.cart-form');
    if (cartForm) {
      clearTimeout(window._cartUpdateTimer);
      window._cartUpdateTimer = setTimeout(() => cartForm.submit(), 700);
    }
  });
});
document.querySelectorAll('.prod-qty input').forEach(inp => {
  inp.addEventListener('click', e => e.stopPropagation());
  inp.addEventListener('blur', () => {
    const v = parseInt(inp.value, 10);
    if (!v || v < 1) inp.value = 1;
  });
});

// ======== CART PROGRESS BAR ========
// SOURCE OF TRUTH WARNING (v13 2026-05-12 · inventario completo verificado en v68 2026-07-28):
// MIN_ORDER duplicated in: settings_data.json (settings.min_order_ars), main-cart.liquid (uses settings.min_order_ars).
//
// Los TRAMOS viven en 13 lugares. Cambiar uno obliga a tocarlos TODOS o desincronizan en
// silencio — ya pasó dos veces (v62 dejó prosa vieja, y esta lista misma estaba incompleta).
//
// EN EL TEMA (lo que el cliente LEE):
//   1. este array TIERS (barra de progreso del cart-bar)
//   2. main-cart.liquid ~:91-96  cálculo del tramo — ⚠️ en CENTAVOS (50000000, no 500000)
//   3. main-cart.liquid ~:145    la misma tabla como texto — ⚠️ ES y ZH en LA MISMA LÍNEA,
//                                un reemplazo por línea deja la mitad vieja
//   4. main-product.liquid ~:245-250  tabla del acordeón de la PDP
//   5. snippets/seo-meta.liquid ~:60  meta description de /pages/descuentos
//   6. templates/index.json           ⚠️ ESTOS DOS son los que REALMENTE se renderizan
//   7. templates/page.descuentos.json    ("amount":"$500k" en los blocks tier)
//   8. discounts.liquid ~:326 (preset del schema — no se renderiza hoy, pero si alguien
//      re-agrega la sección desde el admin reintroduce el valor viejo) y ~:287 (texto de
//      ayuda con el formato de ejemplo)
//
// FUERA DEL TEMA:
//   9. Shopify: los 5 DiscountAutomaticBasic — los únicos que DE VERDAD descuentan en el
//      checkout. Alinear con scripts/discount-tiers-update.cjs (dry-run por defecto).
//  10. scripts/discount-tiers-update.cjs — pisos hardcodeados en NUEVO_PISO y ESPERADO
//  11. cx-integrations/ai-sales/knowledge_base.json → descuentos_por_volumen (web_general
//      Y local_efectivo_general; la tabla del local NO existe en el tema, sólo acá)
//  12. cx-integrations/ai-sales/shopify_tools.py → _TRAMOS_WEB_FALLBACK (y el test
//      test_cuentas_carrito.py «Tope» que asume el tope). emergency_responses.py ya NO
//      tiene tabla (sólo «desde $200.000»).
//  13. cx-integrations/ai-sales/training_data/informacion_cx_mayorista_{es,zh}.txt
//      + la hoja imprimible en Desktop/Claude/descuentos-cx-*.txt
//      + cx/reportes/tiktok-asistente-conocimiento-*.txt (conocimiento del asistente TikTok)
//  2026-10: se quitó el tramo 25% (≥$1,2M) en TODOS estos lugares; el tope web es 20%.
//
// SE ACTUALIZAN SOLOS (no tocar): system_prompt.md y check_facts_consistency.py derivan del
// KB; descuento-drift-check.cjs lee los tramos del KB; el "≈ ahorrás $Xk" de discounts.liquid
// se calcula parseando el "amount" de los templates.
//
// Los 1-8 son sólo lo que el cliente LEE. Si 9 no coincide, el sitio miente.
// scripts/descuento-drift-check.cjs cruza KB ↔ Shopify ↔ elegibilidad — correrlo tras cada cambio.
// TODO P2: refactor to read from <script id="cx-tier-data" type="application/json"> rendered by layout from settings.
const MIN_ORDER = (window.CX_MIN_ORDER || 150000);
// Pisos actualizados 2026-07-28 (los % nunca cambian; sube el monto de cada tramo).
// OJO: `window.CX_TIERS` NO lo asigna nadie en el repo — el array literal de abajo es
// lo que corre siempre. El `||` es el TODO P2 sin hacer, no una inyección real.
// 2026-10: se eliminó el tramo 25% (≥ $1.200.000). El tope web es 20% desde $700.000.
const TIERS = window.CX_TIERS || [
  { min: 200000, pct: 5 },
  { min: 300000, pct: 10 },
  { min: 500000, pct: 15 },
  { min: 700000, pct: 20 }
];
const MAX_TIER = TIERS[TIERS.length - 1].min;

function fmt(n) { return '$' + Math.round(n).toLocaleString('es-AR'); }

// === Excluded product IDs (Perfume + Electrónicos + Oferta) ===
// La fuente es el tag `no-descuento` del producto — nunca la colección.
// Seeded by cart-bar.liquid for items already in cart; PDP add-to-cart
// pushes new excluded PIDs via cxMarkExcluded(). No collection fetching.
window._cxExcludedPids = new Set(window.CX_INITIAL_EXCLUDED_PIDS || []);
window.cxMarkExcluded = function(pid) {
  if (pid) window._cxExcludedPids.add(Number(pid));
};

async function refreshCartBar() {
  try {
    const cartRes = await fetch('/cart.js');
    if (!cartRes.ok) throw new Error('cart.js HTTP ' + cartRes.status);
    const cart = await cartRes.json();
    const excluded = window._cxExcludedPids;
    let discountable = 0, excludedCents = 0;
    cart.items.forEach(item => {
      if (excluded.has(item.product_id)) excludedCents += item.original_line_price;
      else discountable += item.original_line_price;
    });
    renderCart(cart.total_price / 100, cart.item_count, discountable / 100, excludedCents / 100);
  } catch (err) {
    console.error('Cart fetch failed', err);
  }
}

function renderCart(total, items, discountable, excluded) {
  if (discountable === undefined) discountable = total;
  if (excluded === undefined) excluded = 0;
  // v67: badge del ícono de carrito del header — mismo dato, cero requests extra
  const navCount = document.getElementById('navCartCount');
  if (navCount) {
    navCount.textContent = items;
    navCount.classList.toggle('is-empty', items === 0);
  }
  const bar = document.getElementById('cartBar');
  if (!bar) return;

  if (items === 0) {
    renderCart._prev = 0; // v35: que el próximo "+1" sí dispare el pulso del badge
    bar.classList.remove('on');
    document.body.classList.remove('cart-active');
    return;
  }
  bar.classList.add('on');
  document.body.classList.add('cart-active');

  document.getElementById('cbTotal').textContent = fmt(total);
  document.getElementById('cbItems').textContent = items + ' item' + (items > 1 ? 's' : '');
  const _bump = (renderCart._prev !== undefined && items > renderCart._prev); // v35: pulso solo al aumentar
  renderCart._prev = items;
  const badge = document.getElementById('cbCartBadge');
  if (badge) {
    if (items > 0) {
      badge.textContent = items > 99 ? '99+' : items;
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }
    if (_bump) bumpBadge(badge);
  }
  const fabBadge = document.getElementById('cartFabBadge');
  if (fabBadge) {
    fabBadge.textContent = items > 99 ? '99+' : items;
    fabBadge.hidden = items <= 0;
    if (_bump) bumpBadge(fabBadge);
  }

  const barFill = document.getElementById('cbBarFill');
  const cbBar = document.getElementById('cbBar');
  const msg = document.getElementById('cbMsg');
  const checkout = document.getElementById('cbCheckout');
  const chkTxt = document.getElementById('cbCheckoutTxt');
  const chkIcon = document.getElementById('cbCheckoutIcon');

  cbBar.classList.remove('locked', 'maxed');
  msg.classList.remove('locked');
  checkout.classList.remove('locked');

  if (total < MIN_ORDER) {
    const falta = MIN_ORDER - total;
    barFill.style.width = ((total / MIN_ORDER) * 100).toFixed(1) + '%';
    cbBar.classList.add('locked');
    msg.classList.add('locked');
    // El icono va DENTRO de cada span de idioma: .cb-msg es flex-column, si quedara
    // suelto sería su propia fila.
    const lock = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> ';
    msg.innerHTML =
        '<span class="es-only">' + lock + 'Faltan <strong>' + fmt(falta) + '</strong> para el pedido mínimo (' + fmt(MIN_ORDER) + ')</span>'
      + '<span class="zh">' + lock + '还差 <strong>' + fmt(falta) + '</strong> 才够最低订单（' + fmt(MIN_ORDER) + '）</span>';
    checkout.classList.add('locked');
    chkTxt.innerHTML = '<span class="es-only">Pedido mínimo bloqueado</span><span class="zh">未达最低订单</span>';
    chkIcon.innerHTML = '<rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>';
    checkout.href = '#';
    renderTicks(total);
    medirCartBar();
    return;
  }

  chkIcon.innerHTML = '<path d="M5 12h14M13 5l7 7-7 7"/>';
  chkTxt.innerHTML = '<span class="es-only">Finalizar compra</span><span class="zh">完成结账</span>';
  checkout.href = '/checkout';

  const nextTier = TIERS.find(t => discountable < t.min);
  const currentTier = [...TIERS].reverse().find(t => discountable >= t.min);

  msg.replaceChildren();

  // Estas 3 líneas se arman en JS, así que no pueden usar los spans es-only/zh del
  // Liquid — hay que emitirlos acá. Hasta v64 salían SOLO en español, incluso con el
  // sitio en chino (se veía en la barra flotante, que es el componente de conversión
  // más visible del sitio). El CSS de idioma (theme.css: html:not([data-locale=zh]) .zh
  // / html[data-locale=zh] .es-only) hace el resto — mismo patrón que cbCheckoutTxt.
  const par = (esNodes, zhNodes) => {
    const es = document.createElement('span'); es.className = 'es-only'; es.append(...esNodes);
    const zh = document.createElement('span'); zh.className = 'zh'; zh.append(...zhNodes);
    return [es, zh];
  };
  const b = t => { const s = document.createElement('strong'); s.textContent = t; return s; };
  const activo = t => { const s = document.createElement('span'); s.className = 'cb-active'; s.textContent = t; return s; };

  // Línea 1 — monto que cuenta + descuento actual
  const sumLine = document.createElement('span');
  sumLine.className = 'cb-msg-sum';
  sumLine.append(...par(
    ['Cuentan para el descuento: ', b(fmt(discountable)), ...(currentTier ? [activo(' · ✓ ' + currentTier.pct + '% off')] : [])],
    ['可享折扣金额：', b(fmt(discountable)), ...(currentTier ? [activo(' · ✓ ' + currentTier.pct + '% off')] : [])]
  ));
  msg.append(sumLine);

  // Línea 2 — acción (sumá X más → Y%)
  const main = document.createElement('span');
  main.className = 'cb-msg-main';
  if (nextTier) {
    const falta = nextTier.min - discountable;
    const pct = Math.min(100, (discountable / MAX_TIER) * 100);
    barFill.style.width = pct.toFixed(1) + '%';
    main.append(...par(
      ['Sumá ', b(fmt(falta)), ' más en productos con desc. → ', b(nextTier.pct + '% off')],
      ['再加 ', b(fmt(falta)), ' 可享折扣商品 → ', b(nextTier.pct + '% off')]
    ));
  } else {
    barFill.style.width = '100%';
    cbBar.classList.add('maxed');
    var topePct = TIERS[TIERS.length - 1].pct;
    main.append(...par(
      [b('✓ Tramo máximo (' + topePct + '% off) alcanzado')],
      [b('✓ 已达最高档（' + topePct + '% off）')]
    ));
  }
  msg.append(main);

  // Línea 3 — nota de lo que no participa
  if (excluded > 0) {
    const note = document.createElement('span');
    note.className = 'cb-msg-note';
    note.append(...par(
      ['ⓘ Perfume, electrónicos y ofertas (' + fmt(excluded) + ') no aplican ni suman al tramo'],
      ['ⓘ 香水、电子产品和特价商品（' + fmt(excluded) + '）不参与折扣，也不计入档位']
    ));
    msg.append(note);
  }

  renderTicks(discountable);
  renderTickLabels(discountable);
  medirCartBar();
}

// v65: la altura real de .cart-bar depende del contenido — el mensaje pasa a 2 o 3
// líneas según idioma (el chino ocupa distinto), largo del texto y ancho de pantalla.
// Hasta ahora el padding del body y el bottom del botón de WhatsApp eran magic numbers
// calibrados contra "164px medidos" — pero esos 164px se midieron con el carrito VACÍO;
// con carrito real la barra llega a ~240px, tapaba el final de la página y dejaba el
// botón de WhatsApp entero por detrás. Publicamos la altura real y que el CSS calcule.
// (theme.js está cargado con defer, así que el DOM ya está parseado.)
// Se llama SÍNCRONO al final de renderCart(): el callback del ResizeObserver es
// asíncrono, así que apoyarse sólo en él dejaba la variable con la altura vieja
// justo en el frame en que el mensaje cambia de tamaño. El observer queda igual
// para lo que renderCart no ve: rotar el teléfono, reflow al cambiar de idioma.
function medirCartBar() {
  const bar = document.getElementById('cartBar');
  if (!bar) return;
  const h = Math.round(bar.getBoundingClientRect().height);
  if (h > 0) document.documentElement.style.setProperty('--cart-bar-h', h + 'px');
}
(function observarCartBar() {
  const bar = document.getElementById('cartBar');
  if (!bar) return;
  if (typeof ResizeObserver === 'function') new ResizeObserver(medirCartBar).observe(bar);
  else window.addEventListener('resize', medirCartBar);
  medirCartBar();
})();

function renderTickLabels(discountable) {
  const wrap = document.getElementById('cbTickLabels');
  if (!wrap) return;
  wrap.replaceChildren();
  TIERS.forEach(t => {
    const pct = Math.min(100, (t.min / MAX_TIER) * 100);
    const lab = document.createElement('span');
    lab.className = 'cb-tick-label' + (discountable >= t.min ? ' on' : '');
    lab.style.left = pct.toFixed(1) + '%';
    const amt = document.createElement('strong');
    // ≥1M se muestra como "$1,2M" — con el formato viejo el tramo de 1.200.000
    // salía como "$1200k".
    amt.textContent = t.min >= 1000000
      ? '$' + (t.min / 1000000).toLocaleString('es-AR') + 'M'
      : '$' + (t.min / 1000) + 'k';
    lab.append(amt);
    lab.append(document.createElement('br'));
    lab.append(t.pct + '%');
    wrap.append(lab);
  });
}

function renderTicks(total) {
  const ticks = document.getElementById('cbTicks');
  if (!ticks) return;
  const points = [MIN_ORDER, ...TIERS.map(t => t.min)];
  ticks.innerHTML = points.map(p => {
    const pct = Math.min(100, (p / MAX_TIER) * 100);
    const active = total >= p ? 'on' : '';
    return '<span class="' + active + '" style="position:absolute;left:' + pct.toFixed(1) + '%;width:2px;height:6px;background:rgba(255,255,255,.6)"></span>';
  }).join('');
}

// ======== Header Catálogo dropdown (v13/v14: click-only + backdrop dim) ========
(function() {
  const btn = document.getElementById('navCatalogoBtn');
  const menu = document.getElementById('navCatalogoMenu');
  const backdrop = document.getElementById('navCatalogoBackdrop');
  if (!btn || !menu) return;
  function open() {
    btn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-catalogo-open');
  }
  function close() {
    btn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-catalogo-open');
  }
  btn.addEventListener('click', e => {
    e.stopPropagation();
    btn.getAttribute('aria-expanded') === 'true' ? close() : open();
  });
  if (backdrop) backdrop.addEventListener('click', close);
  document.addEventListener('click', e => {
    if (!btn.parentElement.contains(e.target) && e.target !== backdrop) close();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
})();

// ======== Header search panel ========
(function() {
  const btn = document.getElementById('navSearchBtn');
  const panel = document.getElementById('navSearchPanel');
  const input = document.getElementById('navSearchInput');
  if (!btn || !panel || !input) return;
  // 2026-09-25: en <=1024 px el buscador está siempre visible: aria-hidden="true" lo escondía de los lectores
  // de pantalla aunque se viera. Solo va oculto en desktop mientras está cerrado.
  const desk = window.matchMedia('(min-width:1025px)');
  // En /search el panel no se muestra (theme.css): la página tiene su propio buscador y la lupa va a ese.
  const pageInput = document.body.classList.contains('template-search') && document.querySelector('.search-form-input');
  if (pageInput) { btn.removeAttribute('aria-expanded'); btn.removeAttribute('aria-controls'); }
  function syncAria() { panel.setAttribute('aria-hidden', pageInput || (desk.matches && !panel.classList.contains('on')) ? 'true' : 'false'); }
  syncAria();
  if (desk.addEventListener) desk.addEventListener('change', syncAria);
  function open() {
    panel.classList.add('on');
    panel.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    setTimeout(() => input.focus(), 60);
  }
  function close() {
    panel.classList.remove('on');
    syncAria();
    btn.setAttribute('aria-expanded', 'false');
  }
  btn.addEventListener('click', () => {
    if (pageInput) {
      pageInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
      pageInput.focus({ preventScroll: true });
      pageInput.select();
      return;
    }
    panel.classList.contains('on') ? close() : open();
  });
  panel.querySelectorAll('[data-close-search]').forEach(el => el.addEventListener('click', close));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && panel.classList.contains('on')) close(); });
})();

// ======== Predictive search (autocomplete dropdown) ========
(function() {
  const input = document.getElementById('navSearchInput');
  const drop = document.getElementById('navPredictive');
  if (!input || !drop) return;

  const LIMIT = 6, MIN_LEN = 2, DEBOUNCE_MS = 220;
  let timer = null, lastQ = '', activeIdx = -1;

  function money(v) { const n = parseFloat(v) || 0; return '$' + n.toLocaleString('es-AR', { maximumFractionDigits: 0 }); }
  function imgFor(p) {
    if (!p.featured_image || !p.featured_image.url) return '';
    const url = p.featured_image.url;
    const sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'width=160&height=160';
  }
  function clear(el) { while (el.firstChild) el.removeChild(el.firstChild); }
  function el(tag, attrs, text) {
    const e = document.createElement(tag);
    if (attrs) for (const k in attrs) e.setAttribute(k, attrs[k]);
    if (text != null) e.textContent = text;
    return e;
  }
  function bilingual(es, zh) {
    const frag = document.createDocumentFragment();
    frag.appendChild(el('span', { class: 'es-only' }, es));
    frag.appendChild(el('span', { class: 'zh' }, zh));
    return frag;
  }

  function hide() { drop.hidden = true; clear(drop); input.setAttribute('aria-expanded', 'false'); activeIdx = -1; }
  function show() { drop.hidden = false; input.setAttribute('aria-expanded', 'true'); }

  // Un grupo del desplegable ("Categorías" o "Productos"). `sub` devuelve la
  // segunda línea: el precio para productos, un texto fijo para categorías.
  // Los <a> llevan SIEMPRE la clase nav-predictive-item porque es la que usa la
  // navegación con flechas (querySelectorAll más abajo) — si se cambia, el
  // teclado deja de andar.
  function grupo(titEs, titZh, items, sub) {
    if (!items.length) return;
    const header = el('div', { class: 'nav-predictive-header' });
    header.appendChild(bilingual(titEs, titZh));
    drop.appendChild(header);

    const ul = el('ul', { class: 'nav-predictive-list', role: 'presentation' });
    items.slice(0, LIMIT).forEach((p, i) => {
      const li = el('li', { role: 'option', 'data-idx': String(i) });
      const a = el('a', { class: 'nav-predictive-item', href: p.url || '#' });
      const imgWrap = el('div', { class: 'nav-predictive-img' });
      const imgUrl = imgFor(p);
      if (imgUrl) imgWrap.appendChild(el('img', { src: imgUrl, alt: '', loading: 'lazy', width: '48', height: '48' }));
      a.appendChild(imgWrap);
      const meta = el('div', { class: 'nav-predictive-meta' });
      meta.appendChild(el('div', { class: 'nav-predictive-title' }, p.title || ''));
      const linea2 = sub(p);
      if (linea2) {
        const d = el('div', { class: 'nav-predictive-price' });
        if (typeof linea2 === 'string') d.textContent = linea2; else d.appendChild(linea2);
        meta.appendChild(d);
      }
      a.appendChild(meta);
      li.appendChild(a);
      ul.appendChild(li);
    });
    drop.appendChild(ul);
  }

  // 2026-09-24 — FILTRO DE RESULTADOS INVENTADOS (Juan: «客人反馈过多次搜索系统有问题»).
  // suggest.json es difuso: si la palabra no está en ningún título NO devuelve 0,
  // rellena con lo que se parezca ("vajilla" → esponjas, "olla" → collares).
  // Se compara cada producto contra las palabras de la query (sin acentos):
  // título + tipo + marca + tags. 0 palabras → no se muestra. Las palabras con
  // dígitos (códigos, barcode 900173) se dan por buenas: Shopify las encontró por
  // SKU/barcode/variante, que no están en el título. Misma regla que
  // main-search.liquid, misma idea que Cami (shopify_tools.py:181-230).
  const STOP = new Set(['de','del','la','el','los','las','un','una','unos','unas','para','con','sin','por','en','y','o','x','al','a']);
  function fold(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function tokens(q) { return fold(q).split(/[^a-z0-9]+/).filter(t => t.length >= 2 && !STOP.has(t)); }
  // Al PRINCIPIO de palabra, no substring: "olla" está adentro de "COLLAR" y "OLIBOLLA".
  // "plato" sigue encontrando "PLATOS".
  function hits(p, toks) {
    const pajar = fold([p.title, p.type, p.vendor, (p.tags || []).filter(t => t !== 'no-descuento').join(' ')].join(' '));
    let n = 0;
    const esta = t => new RegExp('(^|[^a-z0-9])' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).test(pajar);
    toks.forEach(t => {
      // plural del cliente vs singular del título: "auriculares" → "auricular", "platos" → "plato"
      if (/\d/.test(t) || esta(t) || (t.length > 3 && t.endsWith('s') && esta(t.slice(0, -1))) || (t.length > 4 && t.endsWith('es') && esta(t.slice(0, -2)))) n++;
    });
    return n;
  }
  // Sinónimos (window.CX_SEARCH_SYN, de snippets/search-sinonimos.liquid):
  // "handle=Título:palabra palabra;…" → categoría a sugerir cuando la query trae esa palabra.
  const SYN = [];
  String(window.CX_SEARCH_SYN || '').split(';').forEach(line => {
    const i = line.indexOf(':'); if (i < 0) return;
    const hd = line.slice(0, i).trim().split('='); const words = line.slice(i + 1).trim().split(/\s+/);
    if (hd[0]) SYN.push({ handle: hd[0].trim(), title: (hd[1] || hd[0]).trim(), words: new Set(words) });
  });
  function categoriasPorSinonimo(toks, ya) {
    const vistos = new Set(ya.map(c => c.handle));
    const out = [];
    SYN.forEach(s => {
      if (vistos.has(s.handle)) return;
      if (toks.some(t => s.words.has(t))) { vistos.add(s.handle); out.push({ handle: s.handle, title: s.title, url: '/collections/' + s.handle }); }
    });
    return out;
  }
  function linkWhatsApp(q) {
    const a = el('a', { class: 'nav-predictive-all', href: 'https://wa.me/' + (window.CX_WA || '5491157951826') + '?text=' + encodeURIComponent('Hola! Estoy buscando: ' + q), target: '_blank', rel: 'noopener' });
    a.appendChild(bilingual('Buscar por WhatsApp →', '通过 WhatsApp 找货 →'));
    return a;
  }

  function render(products, collections, q) {
    clear(drop);
    const toks = tokens(q);
    const cols = collections.concat(categoriasPorSinonimo(toks, collections));
    // Productos: solo los que tienen alguna palabra de la query; primero los que tienen todas.
    const prods = products.map((p, i) => ({ p: p, n: hits(p, toks), i: i }))
      .filter(x => x.n > 0 || !toks.length)
      .sort((a, b) => (b.n - a.n) || (a.i - b.i))
      .map(x => x.p);
    if (!prods.length && !cols.length) {
      const empty = el('div', { class: 'nav-predictive-empty' });
      empty.appendChild(bilingual('No encontramos productos para "' + q + '"', '未找到与 "' + q + '" 相关的商品'));
      drop.appendChild(empty);
      drop.appendChild(linkWhatsApp(q));
      show();
      return;
    }
    // Las categorías van primero: cuando alguien escribe "bazar" o "skincare",
    // la categoría es la respuesta, no un producto suelto que casualmente matchea.
    grupo('Categorías', '分类', cols, function() {
      return bilingual('Ver la categoría', '查看分类');
    });
    if (!prods.length) {
      const empty = el('div', { class: 'nav-predictive-empty' });
      empty.appendChild(bilingual('Ningún producto se llama así: mirá la categoría', '没有叫这个名字的商品，可以看上面的分类'));
      drop.appendChild(empty);
      drop.appendChild(linkWhatsApp(q));
      show();
      return;
    }
    grupo('Productos', '商品', prods, function(p) { return money(p.price); });

    // type=product a secas: la página /search de Shopify ignora `collection`
    // (probado 2026-09-01). Las categorías las resuelve main-search.liquid solo.
    const all = el('a', { class: 'nav-predictive-all', href: '/search?q=' + encodeURIComponent(q) + '&type=product' });
    all.appendChild(bilingual('Ver todos los resultados →', '查看所有结果 →'));
    drop.appendChild(all);
    show();
  }

  async function lookup(q) {
    if (q === lastQ) return;
    lastQ = q;
    if (q.length < MIN_LEN) { hide(); return; }
    try {
      // fields: además del título, tipo, variante, marca y tags (los de siempre) se piden
      // SKU y barcode, para que un revendedor pueda pegar el código que ve en el ticket.
      const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product,collection&resources%5Blimit%5D=' + LIMIT
        + '&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,vendor,tag,variants.sku,variants.barcode', { headers: { 'Accept': 'application/json' } });
      if (!r.ok) { hide(); return; }
      const d = await r.json();
      if (q !== input.value.trim()) return;
      const res = (d.resources && d.resources.results) || {};
      render(res.products || [], res.collections || [], q);
    } catch (e) { hide(); }
  }

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < MIN_LEN) { hide(); return; }
    timer = setTimeout(() => lookup(q), DEBOUNCE_MS);
  });
  input.addEventListener('focus', () => {
    const q = input.value.trim();
    if (q.length >= MIN_LEN) lookup(q);
  });
  input.addEventListener('keydown', e => {
    if (drop.hidden) return;
    const items = drop.querySelectorAll('.nav-predictive-item');
    if (!items.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIdx = Math.min(activeIdx + 1, items.length - 1);
      items.forEach((it, i) => it.classList.toggle('is-active', i === activeIdx));
      items[activeIdx].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIdx = Math.max(activeIdx - 1, 0);
      items.forEach((it, i) => it.classList.toggle('is-active', i === activeIdx));
      items[activeIdx].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && activeIdx >= 0) {
      e.preventDefault();
      window.location.href = items[activeIdx].href;
    } else if (e.key === 'Escape') {
      hide();
    }
  });
  document.addEventListener('click', e => {
    if (drop.hidden) return;
    if (e.target === input || drop.contains(e.target)) return;
    hide();
  });
})();

// ======== Mobile drawer ========
(function() {
  const drawer = document.getElementById('navDrawer');
  const burger = document.getElementById('navBurger');
  if (!drawer || !burger) return;
  function open() {
    drawer.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    // 2026-09-25: el foco entra al menú (antes quedaba atrás, en la página tapada)
    const x = drawer.querySelector('.nav-drawer-close');
    if (x) x.focus();
  }
  function close() {
    // el Escape global llama close() aunque el menú esté cerrado: solo devolver el foco si estaba abierto
    const estabaAbierto = drawer.classList.contains('on');
    drawer.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (estabaAbierto) burger.focus();
  }
  burger.addEventListener('click', open);
  drawer.querySelectorAll('[data-close]').forEach(el => el.addEventListener('click', close));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
})();

// ======== Cart-bar minimize/expand ========
(function cartBarMinimize(){
  const collapse = document.getElementById('cbCollapse');
  const fab = document.getElementById('cartFab');
  if (!collapse || !fab) return;

  if (sessionStorage.getItem('cartBarMinimized') === '1') {
    document.body.classList.add('cart-minimized');
  }

  collapse.addEventListener('click', () => {
    document.body.classList.add('cart-minimized');
    sessionStorage.setItem('cartBarMinimized', '1');
  });

  fab.addEventListener('click', () => {
    document.body.classList.remove('cart-minimized');
    sessionStorage.removeItem('cartBarMinimized');
  });
})();

// ======== Init on page load ========
document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('cartBar')) {
    refreshCartBar();
  }
});

// ======== Horizontal scroll hint (mobile · chevron + bounce) ========
function setupScrollHint(shell, scrollerSelector, storageKey){
  const scroller = shell.querySelector(scrollerSelector);
  if (!scroller) return;
  const isScrollable = () => scroller.scrollWidth - scroller.clientWidth > 4;
  const updateOverflow = () => shell.classList.toggle('has-overflow', isScrollable());
  const updateEnd = () => {
    const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
    shell.classList.toggle('is-end', atEnd);
  };
  updateOverflow();
  updateEnd();
  scroller.addEventListener('scroll', updateEnd, {passive:true});
  window.addEventListener('resize', () => { updateOverflow(); updateEnd(); }, {passive:true});
  // Web font (Poppins) loads async — chip widths change after swap, re-measure
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { updateOverflow(); updateEnd(); });
  window.addEventListener('load', () => { updateOverflow(); updateEnd(); }, {once:true});

  if (!storageKey || !isScrollable()) return;
  if (sessionStorage.getItem(storageKey)) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      setTimeout(() => {
        scroller.scrollTo({left: 80, behavior: 'smooth'});
        setTimeout(() => scroller.scrollTo({left: 0, behavior: 'smooth'}), 750);
      }, 350);
      try { sessionStorage.setItem(storageKey,'1'); } catch(e){}
      obs.disconnect();
    });
  }, {threshold: 0.6});
  obs.observe(shell);
}

(function initScrollHints(){
  if (!window.matchMedia('(max-width:640px)').matches) return;
  document.querySelectorAll('.hero-visual-shell').forEach(s => setupScrollHint(s, '.hero-visual', 'cx_hero_hint_seen'));
  document.querySelectorAll('.cats-scroll-shell').forEach(s => setupScrollHint(s, '.cats', 'cx_cats_hint_seen'));
  document.querySelectorAll('.ts-scroll-shell').forEach(s => setupScrollHint(s, '.ts-scroll', 'cx_ts_hint_seen'));
  document.querySelectorAll('.disc-scroll-shell').forEach(s => setupScrollHint(s, '.disc-grid', 'cx_disc_hint_seen'));
  document.querySelectorAll('.coll-subs-shell').forEach(s => setupScrollHint(s, '.coll-subs', 'cx_subs_hint_seen'));
})();

// ======== Collection · Cargar más AJAX (mobile pagination fix) ========
(function collLoadMore(){
  const grid = document.getElementById('products');
  const lm = document.querySelector('.coll-load-more');
  if (!grid || !lm) return;

  const btn = lm.querySelector('.coll-load-more-btn');
  const meta = lm.querySelector('.coll-load-more-meta');
  let nextUrl = lm.dataset.nextUrl;
  let loading = false;

  // JS-enabled path: reveal Cargar más, hide numbered pagination fallback
  lm.hidden = false;
  const oldPag = lm.parentElement.querySelector('.pagination');
  if (oldPag) oldPag.style.display = 'none';

  btn.addEventListener('click', async () => {
    if (loading || !nextUrl) return;
    loading = true;
    btn.disabled = true;
    btn.classList.remove('is-error');
    btn.classList.add('is-loading');

    try {
      const r = await fetch(nextUrl, { credentials: 'same-origin' });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.getElementById('products');
      if (!newGrid) throw new Error('Grid not found');

      const newCards = newGrid.querySelectorAll(':scope > article.ts-card');
      if (!newCards.length) throw new Error('No products in next page');
      const frag = document.createDocumentFragment();
      newCards.forEach(c => frag.appendChild(c));
      grid.appendChild(frag);

      const newLm = doc.querySelector('.coll-load-more');
      const newNext = newLm ? newLm.dataset.nextUrl : null;
      if (newNext) {
        nextUrl = newNext;
        lm.dataset.nextUrl = newNext;
        const newMeta = doc.querySelector('.coll-load-more-meta');
        if (newMeta && meta) {
          meta.replaceChildren(...newMeta.childNodes);
        }
      } else {
        nextUrl = null;
        lm.hidden = true;
      }
    } catch (err) {
      console.error('Cargar más failed:', err);
      btn.classList.add('is-error');
    } finally {
      loading = false;
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  });
})();

/* ======== v35 motion: scroll-reveal entrances ======== */
(function revealOnScroll(){
  var nodes = document.querySelectorAll('.reveal-on-scroll, .reveal-stagger');
  if (!nodes.length) return;
  if (CX_RM || !('IntersectionObserver' in window)){
    nodes.forEach(function(n){ n.classList.add('is-in'); });   // degrade: show everything
    return;
  }
  document.querySelectorAll('.reveal-stagger').forEach(function(g){
    Array.prototype.forEach.call(g.children, function(c, i){ c.style.setProperty('--i', i); });
  });
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  nodes.forEach(function(n){ io.observe(n); });
})();

/* ======== 2026-09-26: "¿Qué es la melamina?" plegable en teléfono (CSS en .melamina-explainer) ======== */
(function explainerPlegable(){
  var mq = window.matchMedia('(max-width:560px)');
  document.querySelectorAll('.melamina-explainer').forEach(function(box){
    var head = box.querySelector('.melamina-explainer-head');
    if (!head) return;
    function sync(){
      if (mq.matches){
        head.setAttribute('role', 'button'); head.setAttribute('tabindex', '0');
        head.setAttribute('aria-expanded', box.classList.contains('is-open') ? 'true' : 'false');
      } else {
        head.removeAttribute('role'); head.removeAttribute('tabindex'); head.removeAttribute('aria-expanded');
      }
    }
    function toggle(){
      if (!mq.matches) return;
      box.classList.toggle('is-open');
      sync();
    }
    head.addEventListener('click', toggle);
    head.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggle(); } });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    sync();
  });
})();
